const STATUS_VIEWS = {
    active: {
        label: 'Активен',
        description: 'Доступ предоставлен',
        tone: 'green',
    },
    awaiting_cutoff: {
        label: 'Истекает сегодня',
        description: 'Срок истекает сегодня, доступ пока работает',
        tone: 'amber',
    },
    disabled: {
        label: 'Отключён',
        description: 'Доступ отключён из-за недостатка средств',
        tone: 'red',
    },
    disabled_by_support: {
        label: 'Отключён поддержкой',
        description: 'Доступ отключён вручную поддержкой',
        tone: 'red',
    },
};
export function accountStatusView(status) {
    if (status == null) {
        return {
            label: 'Нет аккаунта',
            description: 'Аккаунт ещё не создан',
            tone: 'gray',
        };
    }
    if (Object.prototype.hasOwnProperty.call(STATUS_VIEWS, status)) {
        return STATUS_VIEWS[status];
    }
    return {
        label: 'Отключён',
        description: 'Неизвестный статус — считаем аккаунт отключённым',
        tone: 'red',
        raw: status,
    };
}
